<template>
  <v-menu
    left
    offset-y
  >
    <template #activator="{ on }">
      <v-btn class="action-menu" text v-on="on">
        <v-icon class="fin-color-primary-dark--text">icon-contextmenu-vertical</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item :key="action.name"
                   :disabled="(action.disabled && action.disabled(item)) || false"
                   @click="action.click(item)"
                   v-for="action in actions">
        <v-list-item-icon v-if="'icon' in action">
          <v-icon :color="(action.disabled && action.disabled(item)) ? $finColors.accentGray2 : $finColors.primaryDark">
            {{ action.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title
          :style="{ color: (action.disabled && action.disabled(item))  ? $finColors.accentGray2 : $finColors.primaryDark }">
          {{ action.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "ActionsCell",
  props: {
    item: {},
    header: {}
  },
  computed: {
    componentProps() {
      return this.header.componentProps
    },
    actions() {
      return this.componentProps.actions
    }
  },
  methods: {}
}
</script>

<style scoped>
.action-menu {
  min-width: unset !important;
  padding: 0 !important;
}
</style>
